<template>
    <button class="btn bg-transparent p-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasProducts" aria-controls="offcanvasProducts" id="offcanvasProductsBTN"></button>
    
    <div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasProducts" aria-labelledby="offcanvasProductsLabel">
      <div class="offcanvas-header">
        <h6 class="offcanvas-title text-dark" id="offcanvasProductsLabel" style="display: flex;align-items: flex-end;font-weight: 700;">محصولات زیر به دلیل ناموجود بودن از سبد خرید شما حذف شدند</h6>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body small text-dark">
      
       <table class="table table-striped table-hover">
       <tbody>
       <tr v-for="item in props.items" :key="item.id">
        <!-- <td><img :src="'https://radap.ir/'+item.img_url" width="30" height="30" /></td> -->
        <td style="vertical-align: middle;">{{ item.name }}</td>
        <td style="vertical-align: middle;">{{ item.quantity }} عدد</td>
       </tr>
       </tbody>
       </table>
        <button class="btn btn-outline-success text-dark w-100 mt-1 ml-1" type="button" data-bs-dismiss="offcanvas" @click="$emit('updateUnavailable')">متوجه شدم</button>
        <!-- <button class="btn btn-success text-light w-48 mt-1" type="button" @click="$emit('goGetway')">پرداخت</button> -->
      </div>
    </div>
</template>
<script setup>
import {defineProps} from 'vue'
let props = defineProps(['items'])
</script>
<style>
    .offcanvas {
        left: 0;
        right: 0;
        height: auto;
        z-index: 100010;
    }
    
    .offcanvas-backdrop {
        background-color: transparent !important;
    }
    .w-48{
      width:48%;
    }
</style>